<template>
  <a-modal title="Edit Shipping Address" centered :visible="true" :closable="false" class="shipping-address-form">
    <template slot="footer">
      <a-button key="back" @click="$emit('onClose')"> Cancel </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="updateShippingInfo"> Save </a-button>
    </template>

    <a-form :form="form" :layout="'vertical'">
      <a-row :md="{ span: 22, offset: 2 }">
        <a-col>
          <a-form-item :label="'Name'">
            <a-input v-decorator="['nickname']" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :md="{ span: 22, offset: 2 }">
        <a-col>
          <a-form-item :label="'Street 1'">
            <a-input v-decorator="['address1']" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :md="{ span: 22, offset: 2 }">
        <a-col>
          <a-form-item :label="'Street 2'">
            <a-input v-decorator="['address2']" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :md="{ span: 8, offset: 1 }" style="margin-left: 0 !important;">
          <a-form-item :label="'City'">
            <a-input v-decorator="['city']" />
          </a-form-item>
        </a-col>
        <a-col :md="{ span: 8, offset: 1 }">
          <a-form-item :label="'State'">
            <a-input v-decorator="['state']" />
          </a-form-item>
        </a-col>
        <a-col :md="{ span: 6, offset: 1 }">
          <a-form-item :label="'Zip Code'">
            <a-input v-decorator="['zipcode']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex';
import { isEmpty } from 'lodash';
import UserService from '@/services/UserService';
export default {
  name: 'Home',
  data: function () {
    return {
      isShippingVisible: false,
      loading: false,
    };
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.form = this.$form.createForm(this, { name: 'shippingInfo' });

    const shippingInfo = this.user.user.shippingInfo;
    setTimeout(() => {
      if (!isEmpty(shippingInfo)) {
        const { nickname, address1, address2, city, state, zipcode } = shippingInfo;
        this.form.setFieldsValue({
          nickname,
          address1,
          address2,
          city,
          state,
          zipcode,
        });
      }
    });
  },
  methods: {
    async updateShippingInfo() {
      const shipping = this.form.getFieldsValue();
      try {
        this.loading = true;
        const resp = await UserService.doUpdateShippingInfo(shipping);
        await this.$store.dispatch('updateUser', {
          user: {
            ...this.user.user,
            shippingInfo: resp,
          },
        });
        this.$emit('onClose', true);
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.shipping-address-form {
  .ant-form-item {
    padding-bottom: 0;

    .ant-form-item-label,
    label {
      margin-bottom: 0;
    }
  }
}
</style>
